import { Component } from '@angular/core'
import { ProspectingService } from 'src/app/services/prospecting.service'

@Component({
    selector: 'app-admin-prospecting-assistant',
    templateUrl: './admin-prospecting-assistant.component.html',
    styleUrls: ['./admin-prospecting-assistant.component.scss'],
})
export class AdminProspectingAssistantComponent {
    prompt = ''
    results: any[] = []
    researching = false
    importing = false
    message = ''
    error = ''
    mapCenter = { lat: -33.9249, lng: 18.4241 }
    mapZoom = 11

    constructor(private prospecting: ProspectingService) {}

    get selectedCount(): number {
        return this.results.filter((r) => r.selected).length
    }

    async research(): Promise<void> {
        this.message = ''
        this.error = ''
        if (!this.prompt.trim()) {
            this.error = 'Please enter a research prompt'
            return
        }
        this.researching = true
        try {
            const data = await this.prospecting.claudeResearch(this.prompt)
            this.results = (data?.companies || []).map((c: any) => ({ ...c, selected: true }))

            if (!this.results.length) {
                this.message = 'Claude returned no companies for this prompt. Try rephrasing or broadening it.'
            }

            if (this.results.length) {
                const first = this.results.find((r) => r.latitude && r.longitude)
                if (first) {
                    this.mapCenter = { lat: first.latitude, lng: first.longitude }
                }
            }
        } catch (e: any) {
            this.error = e?.message || 'Research failed'
        } finally {
            this.researching = false
        }
    }

    async importSelected(): Promise<void> {
        const selected = this.results.filter((r) => r.selected)
        if (!selected.length) {
            this.error = 'No companies selected'
            return
        }
        this.message = ''
        this.error = ''
        this.importing = true
        try {
            const data = await this.prospecting.importClaudeResults(selected, this.prompt)
            this.message = `Imported ${data?.created ?? selected.length} prospect(s) successfully.`
        } catch (e: any) {
            this.error = e?.message || 'Import failed'
        } finally {
            this.importing = false
        }
    }
}
